import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_packing_list_stock_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    packing_list_hdr_guid : fromDatatype.GuidDataFieldInterface;
    packing_list_running_no: fromDatatype.VarcharDatatypeInterface;
    gendoc_server_doc_1: fromDatatype.VarcharDatatypeInterface;
    gendoc_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    from_location_guid: fromDatatype.GuidDataFieldInterface;
    from_location_code: fromDatatype.VarcharDatatypeInterface;
    to_location_guid: fromDatatype.GuidDataFieldInterface;
    to_location_code: fromDatatype.VarcharDatatypeInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    comp_code: fromDatatype.VarcharDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_wms_packing_list_stock_link_RowClass implements bl_wms_packing_list_stock_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    packing_list_hdr_guid : fromDatatype.GuidDataFieldInterface;
    packing_list_running_no: fromDatatype.VarcharDatatypeInterface;
    gendoc_server_doc_1: fromDatatype.VarcharDatatypeInterface;
    gendoc_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    from_location_guid: fromDatatype.GuidDataFieldInterface;
    from_location_code: fromDatatype.VarcharDatatypeInterface;
    to_location_guid: fromDatatype.GuidDataFieldInterface;
    to_location_code: fromDatatype.VarcharDatatypeInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    comp_code: fromDatatype.VarcharDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}